// React
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router';
import PropTypes from 'prop-types';

// Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// Actions
import { handleAAASignupLogin } from '../../../actions/LoginAction';

// Components
import StyledButton from '../../Shared/Button';
import Loader from '../../Shared/Utils/Loader';
import CheckBox from '../../../msreact-kit/html-components/check-box';

// Data
import { accessRoles } from '../../../data/appConstants';
import idConstants from '../../../data/idConstants';

// Utils
import { getDeviceClass } from '../../../utils';

// Assets
import { CDN_LINK } from '../../../assets/img';

// CSS
import './login-ciam.scss';


function LoginCiam(props) {
  const loginContent = props?.content?.components?.login;
  const [confirmationModalLoader, setConfirmationModalLoader] = useState(false);
  const [selectedRole, setSelectedRole] = useState(accessRoles.seller);
  const history = useHistory();

  const adfsLogin = process.env.REACT_APP_SKID_STYLE_IDP_HINT_SALES;
  const deviceClass = getDeviceClass();
  useEffect(() => {
    if (props?.location?.pathname === '/login') {
      setConfirmationModalLoader(false);
    }
  }, [props]);


  const pushDashboardPage = () => {
    if (accessRoles.csm === props?.user?.roles?.[0])
      history.push('/dashboard/place-order');
    else history.push('/dashboard');
  };
  const handleSellerOnUsp = () => {
    setConfirmationModalLoader(true);
    handleAAASignupLogin();
  };
  const handleBoschLoginOnUsp = () => {
    setConfirmationModalLoader(true);
    handleAAASignupLogin(adfsLogin);
  };



  const handleLogin = () => {
    if (selectedRole === accessRoles.seller) {
      handleSellerOnUsp();
      localStorage.setItem(idConstants.userLoginIdp, idConstants.idp.skid);
    } else if (selectedRole === accessRoles.bosch_login) {
      handleBoschLoginOnUsp();
      localStorage.setItem(idConstants.userLoginIdp, idConstants.idp.adfs);
    }
  };

  const getWelcomeSubtitle = () => {
    const role = loginContent?.type?.find((item) => item.id.toUpperCase() === selectedRole);
    return (
      <div className='description-container'>
        {role?.description_1}
      </div>
    );
  };

  return (
    <React.Fragment>
      {!props.accessToken ? (
        <div className={`login-ciam-container ${deviceClass}`}>
          <div className='grid-container'>
            <div className='grid-item'>
              <p className='welcome-message_text_1'>
                {loginContent?.title_1}
              </p>
              <p className='welcome-message_text_2'>
                {loginContent?.title_2}
              </p>
            </div>
            <div className='grid-item'>
              <p className='welcome-body'>
                {loginContent?.subTitle_1}
              </p>
              <p className='welcome-body'>
                {loginContent?.subTitle_2}
              </p>
            </div>
            <div>
              <p className='login-us'>{loginContent?.login_as}</p>
            </div>
            <div
              className={
                'seller-sales-rep-container'
              }
            >
              {loginContent?.type?.map((tenant) => {
                const role = tenant.id.toUpperCase();
                const sellerAccess = accessRoles.seller;
                const boschLoginAccess = accessRoles.bosch_login;
                return (
                  <div key={tenant?.id}>
                    <button
                      className={`seller-sales-rep ${(role === sellerAccess) ? 'seller-container' : 'sales-rep-container'}`}
                      onClick={() => setSelectedRole(role)}
                    >
                      <CheckBox
                        displayName=''
                        id={role}
                        name='role'
                        handleChange={() => setSelectedRole(role)}
                        checked={selectedRole === role}
                        className='radio-button'
                      />
                      <img
                        className='seller-sales-rep-image'
                        src={`${CDN_LINK}/${tenant.icon}`}
                        alt=''
                      />
                      <p className={`seller-sales-rep-text ${(role === boschLoginAccess) && 'sales-rep-text'}`}>
                        {tenant.label}
                      </p>
                    </button>
                  </div>
                );
              })}

            </div>
            <div className='grid-item'>
              <StyledButton
                variant='contained'
                label={loginContent?.login_button}
                onClick={handleLogin}
                className='btn-style'
              />
            </div>
            <div className='grid-item'>
              {getWelcomeSubtitle()}
            </div>
          </div>
        </div>
      ) : (
        pushDashboardPage()
      )}
      {confirmationModalLoader && <Loader />}
    </React.Fragment>
  );
}

const mapStateToProps = (redux_state) => ({
  accessToken: redux_state.loginReducer.accessToken,
  content: redux_state.ContentReducer.content,
  user: redux_state.loginReducer.user
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      handleAAASignupLogin
    },
    dispatch
  );
}

LoginCiam.propTypes = {
  user: PropTypes.object
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginCiam);
